import { render, staticRenderFns } from "./StatistiquesTable.vue?vue&type=template&id=00ce0fac"
import script from "./StatistiquesTable.vue?vue&type=script&lang=js"
export * from "./StatistiquesTable.vue?vue&type=script&lang=js"
import style0 from "./StatistiquesTable.vue?vue&type=style&index=0&id=00ce0fac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports